import { presets } from 'assets'
import {
  EventHighlightDTO,
  ProductDTO,
  ViewerEventEnums
} from 'models'

export interface SalesDTO {
  addToCart: number
  commission: number
  count: number
  total: number
}
export interface ProductSalesDTO {
  productId: number
  sales: SalesDTO
}

export interface OrderProductStatsDTO {
  countCart: number
  deltaCart: number
  deltaCommission: number
  deltaPurchases: number
  deltaRevenue: number
  purchases: number
  topCart: ProductSalesDTO
  topCommission: ProductSalesDTO
  topOrdered: ProductSalesDTO
  topRevenue: ProductSalesDTO
  totalCommission: number
  totalRevenue: number
}

export type EventHighlights = {
  [key in ViewerEventEnums]: EventHighlightDTO
}

export type PieSegment = {
  percentage: number
  percentageSkip?: number
  label: string
  deltaPercentage: number
  num: number
  customFormattedTime?: any
  isPrice?: boolean
  afterNumLabel?: string
  bestItem?: {
    product?: ProductDTO
    productId: number
    productStatNumber: number
    isPrice?: boolean
    afterStatNumberLabel?: string
    showStoreName?: boolean
  }
}

export type StoreViewData = {
  total: number
  isTotalPrice?: boolean
  afterTotalLabel?: string
  pieSegments: PieSegment[]
}

export enum ShopHighlightTabs {
  BY_REVENUE = 'BY REVENUE',
  BY_INTERACTIONS = 'BY INTERACTIONS',
  BY_VIEWERS = 'BY VIEWERS',
  BY_EXPENSES = 'BY EXPENSES'
}

export const statsColorPallette = [
  {
    background: presets.backgroundHighlight,
    fill: presets.primary
  },
  {
    background: '#CDEEE9',
    fill: '#70D6C6'
  },
  {
    background: '#B7C6F0',
    fill: '#2D65FF'
  },
  {
    background: '#E2F2FC',
    fill: '#2985AE'
  },
  {
    background: '#D2D4DE',
    fill: '#254291'
  },
  {
    background: '#EFD2F8',
    fill: '#B021D9'
  },
  {
    background: '#47BF63',
    fill: '#47BFAD'
  },
  {
    background: '#9DAAB3',
    fill: '#2985BC'
  },
  {
    background: '#D2B4AE',
    fill: '#271271'
  }
]
